// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    outline: none;
}

html, body {
    margin: 0;
    padding: 0;
}

#Magor {
    width: 100vw;
    height: 100vh;
    position: relative;
}

#LoginBar {
    width: 100%;
    position: fixed;
    display: flex;
    justify-content: flex-end;
    padding: 10px;
}

* {
    font-family: 'Roboto';
}

#SearchName {
    position: absolute;
    bottom: 0;
    right: 67px;
    opacity: 1;
    transition: opacity 0.5s ease;
}

#SearchName.small {
    right: 47px;
}

#SearchName .dropDown {
    width: 110px !important;
    min-width: 0;
}

#SearchName::before {
    content: 'Search By:';
    font-weight: bold;
    position: absolute;
    background: #1faeff;
    color: #fff;
    width: 110px;
    right: 0;
    top: -28px;
    height: 28px;
    display: flex;
    align-items: flex-end;
    padding: 0 15px;
    box-sizing: border-box;
}

#SearchName.small::before {
    top: -20px;
    height: 20px;
    font-size: 14px;
    padding: 0 10px;
}

#Magor .searchBar {
    min-width: 600px;
}

#SearchName.hidden {
    opacity: 0;
}

#AddFilters {
    align-self: flex-start;
}

#AddFilters .addFilterButton {
    color: blue;
    appearance: none;
    padding: 0;
    margin: 0 5px;
    background: transparent;
    border: 0px;
    font-size: inherit;
    cursor: pointer;
    text-transform: capitalize;
}

#AddFilters .addFilterButton:hover {
    text-decoration: underline;
}

#Magor .labelledInputContainer {
    align-self: flex-start;
    margin-top: 10px;
}



#root {
    overflow-x: hidden;
}`, "",{"version":3,"sources":["webpack://./src/Magor/index.css"],"names":[],"mappings":"AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IAGX,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;;;AAIA;IACI,kBAAkB;AACtB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');\n\n* {\n    outline: none;\n}\n\nhtml, body {\n    margin: 0;\n    padding: 0;\n}\n\n#Magor {\n    width: 100vw;\n    height: 100vh;\n    position: relative;\n}\n\n#LoginBar {\n    width: 100%;\n    position: fixed;\n    display: flex;\n    justify-content: flex-end;\n    padding: 10px;\n}\n\n* {\n    font-family: 'Roboto';\n}\n\n#SearchName {\n    position: absolute;\n    bottom: 0;\n    right: 67px;\n    opacity: 1;\n    transition: opacity 0.5s ease;\n}\n\n#SearchName.small {\n    right: 47px;\n}\n\n#SearchName .dropDown {\n    width: 110px !important;\n    min-width: 0;\n}\n\n#SearchName::before {\n    content: 'Search By:';\n    font-weight: bold;\n    position: absolute;\n    background: #1faeff;\n    color: #fff;\n    width: 110px;\n    right: 0;\n    top: -28px;\n    height: 28px;\n    display: flex;\n    align-items: flex-end;\n    padding: 0 15px;\n    box-sizing: border-box;\n}\n\n#SearchName.small::before {\n    top: -20px;\n    height: 20px;\n    font-size: 14px;\n    padding: 0 10px;\n}\n\n#Magor .searchBar {\n    min-width: 600px;\n}\n\n#SearchName.hidden {\n    opacity: 0;\n}\n\n#AddFilters {\n    align-self: flex-start;\n}\n\n#AddFilters .addFilterButton {\n    color: blue;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    padding: 0;\n    margin: 0 5px;\n    background: transparent;\n    border: 0px;\n    font-size: inherit;\n    cursor: pointer;\n    text-transform: capitalize;\n}\n\n#AddFilters .addFilterButton:hover {\n    text-decoration: underline;\n}\n\n#Magor .labelledInputContainer {\n    align-self: flex-start;\n    margin-top: 10px;\n}\n\n\n\n#root {\n    overflow-x: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
